import React from "react";
import classNames from "classnames";
import Select, { components } from "react-select";

const ReactSelect = ({ options, ...props }) => {
  return <Select options={options} {...props} />;
};

const filterHandler = (option, inputValue) => {
  return option.label.toUpperCase().startsWith(inputValue.toUpperCase());
};

export const OutlinedReactSelect = ({
  value,
  loading,
  placeholder,
  icon,
  options = [],
  onChange,
}) => (
  <Select
    filterOption={filterHandler}
    isLoading={loading}
    options={options}
    value={options.find(item => item.value === value)}
    backspaceRemovesValue
    controlShouldRenderValue
    className="react-select-outlined"
    classNamePrefix="react-select-outlined"
    placeholder={placeholder}
    onChange={onChange}
    components={{
      ValueContainer: ({ className, ...props }) => (
        <div className="flex flex-grow relative">
          {icon && (
            <div className="absolute ltr:left-0 h-12 rtl:right-0 ltr:pl-2 rtl:pr-2 flex items-center pointer-events-none h-full">
              {icon}
            </div>
          )}
          <components.ValueContainer
            className={classNames(icon && "ltr:pl-10 rtl:pr-10", className)}
            {...props}
          />
        </div>
      ),
    }}
  />
);

export default ReactSelect;
